import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';





export default function ExpensesTable({data}) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell align="">Category</TableCell>
            <TableCell align="">Amount</TableCell>
              <TableCell align="">Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
  {data}
        
        </TableBody>
      </Table>
    </TableContainer>
  );
}
